export const manageShifts = {
  copyShiftDefault: '%shiftName% (Copy)',
  toasts: {
    hide: {
      success: '%shiftName% has been hidden',
      error: '%shiftName% could not be hidden'
    },
    unhide: {
      success: '%shiftName% has been unhidden',
      error: '%shiftName% could not be unhidden'
    },
    create: {
      success: '%shiftName% successfully created.'
    },
    edit: {
      success: '%shiftName% successfully updated.'
    },
    copy: {
      success: '%shiftName% successfully created.'
    }
  },
  table: {
    header: 'Manage Schedules',
    createNewShift: 'Create new shift',
    days: {
      sunday: 'SUN',
      monday: 'MON',
      tuesday: 'TUE',
      wednesday: 'WED',
      thursday: 'THU',
      friday: 'FRI',
      saturday: 'SAT'
    },
    emptyState: {
      header: 'Create, manage and customize all your shifts',
      description: 'Shifts allow you to schedule any number of job requests at a specific location',
    },
    noResultsHeader: 'No Shifts',
    noResultsContent: 'Create a new shift or select another location',
    schedule: {
      placeholder: '--',
      content: '%startTime% - %endTime%'
    },
    filters: {
      visibility: {
        label: 'Visibility',
        all: 'All',
        visible: 'Visible',
        hidden: 'Hidden'
      }
    },
    shiftName: 'SCHEDULE NAME',
    actions: {
      buttonTitle: 'Actions',
      hide: 'Hide',
      unhide: 'Unhide'
    },
    restricted: {
      copy: {
        header: 'Edit Shift Not Permitted',
        content: 'Shift Schedule currently in use and can not be edited at this time. Current and upcoming job requests must be completed or cancelled.'
      },
      visibility: {
        header: 'Hide Shift Not Permitted',
        content: 'Shift Schedule currently in use and can not be hidden at this time. Current and upcoming job requests must be completed or cancelled.'
      }
    }
  },
  form: {
    create: {
      header: 'Create New Shift'
    },
    edit: {
      header: 'Edit Shift'
    },
    copy: {
      header: 'Create Shift'
    },
    location: {
      header: 'Location',
      description: 'Select a location and enter a unique name for your shift',
      venueLabel: 'Location',
      nameLabel: 'Schedule Name'
    },
    time: {
      header: 'Time',
      description: 'Enter the paid and unpaid time of a shift',
      startTime: 'Start time',
      endTime: 'End time',
      unpaidTime: 'Unpaid time (minutes)',
      startTimePlaceholder: 'Enter start time',
      endTimePlaceholder: 'Enter end time',
      unpaidTimePlaceholder: 'Enter value',
      totalPaidTime: 'Total Paid time',
      customizeHours: 'Customize hours by day',
      totalTime: '%hours%hrs %minutes%min',
      totalTimePlaceholder: '--',
      overnight: 'Overnight'
    },
    daysOfWeek: {
      header: 'Day(s) of Week',
      description: 'Select the days of the week that your shift occurs on',
      disabledText: 'Days of the week can not be modified until current and upcoming job postings are completed or cancelled.'
    },
    buttons: {
      saveAndCreateAnother: 'Save & create another',
      save: 'Save shift'
    },
    validationErrors: {
      startTimeError: 'Start time cannot be after or the same as end time',
      venueMissing: 'Location is a required field',
      nameMissing: 'Name is a required field',
      nameTooLong: 'Name cannot exceed 250 characters',
      missingTimeDetails: 'Please enter the missing shift time details',
      unpaidTimeLessThanZero: 'Unpaid time cannot be less than 0',
      unpaidTimeGreaterThanTwentyFourHours: 'Unpaid time cannot be greater than 24 hours',
      paidTimeGreaterThanTwentyFourHours: 'Job duration cannot be greater than 24 hours',
      unpaidTimeGreaterThanPaidTime: 'Unpaid time cannot be longer than paid time',
      daysOfWeekMissing: 'Select at least one day of the week'
    },
    editConfirmation: {
      header: 'Confirm Shift Changes',
      updateFuture: 'Changes will only update %upcomingJobRequestCount% future jobs',
      createNewAndUpdate: 'A new shift schedule will be created and %upcomingJobRequestCount% jobs will be updated to follow the new schedule.'
    }
  },
};
